/**
 * Operator console destinations. A subscription admin (company_admin on a
 * paying account) does not see these. The API still rejects the call.
 *
 * Menu hiding is not the security check. It keeps a person from opening a
 * page that can only answer "NextCompli admin role is required."
 */

export const STAFF_ONLY_NAV_IDS: readonly string[] = [
  'admin',
  'billing',
  'costOptimization',
  'dashboards',
  'expiredSubscriptions',
  'keycloakAdmin',
  'payingSubscriptions',
  'socials',
  'style',
  'subscriptionHub',
  'subscriptionLevels',
  'subscriptions',
  'tips',
  'voiceMessages',
];

const STAFF_ONLY = new Set(STAFF_ONLY_NAV_IDS);

type PlatformAdminUser = {
  is_platform_admin?: boolean;
} | null | undefined;

/** True only when the server profile says so. A job role on a paying account does not qualify. */
export function isNextCompliAdmin(user: PlatformAdminUser): boolean {
  return user?.is_platform_admin === true;
}

export function isStaffOnlyConsoleNavItem(itemId: string): boolean {
  return STAFF_ONLY.has(itemId);
}

export function filterStaffNavItems<T extends { id: string }>(
  items: readonly T[],
  isPlatformAdmin: boolean,
): T[] {
  if (isPlatformAdmin) {
    return [...items];
  }
  return items.filter((item) => !STAFF_ONLY.has(item.id));
}
